<template>
    <modal v-model:show="modalTurnOff" :showClose="false" :clickClose="false">
        <template v-slot:header>
            <h5 class="modal-title d-flex justify-content-center">You are about to off the connection</h5>
        </template>
        <form>
            <div class="mb-3">
                <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
            </div>
            <div class="mb-3">
                <label for="user-input"
                    class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
                    please enter the provided number:
                </label>
                <input type="text" v-model="userInput"
                    class="form-control d-flex justify-content-center align-item-center" id="user-input" maxlength="3"
                    placeholder="Enter 3-digit number" />
            </div>
        </form>
        <div class="mt-4 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
            <button class="btn btn-primary" type="button" @click="validateInput();">power Off</button>
        </div>
        <div class="mt-3 d-flex justify-content-center">
            <small class="text-danger">{{ validationMessage }}</small>
        </div>
        <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
            <small class="text-danger">{{ errorMessage }}</small>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
    components: {
        Modal,
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        modalTurnOff: {
            type: Boolean,
            default: false,
        },
        currentUser: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isPlaying: false,
            positons: [],
            users: [],
            currentUser: {},
            errorFlag: false,
            errorMessage: "",
            randomNum: '',
            userInput: "",
            validationMessage: "",
            otp: ""
        }
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                this.randomNum = Math.floor(100 + Math.random() * 900);
            }
        },
    },
    methods: {
        closeModal() {
            this.errorFlag = false;
            this.validationMessage = "";
            this.userInput = "";
            this.$emit('updateParameters', false, false);
        },
        validateInput() {
            if (parseInt(this.userInput) === this.randomNum) {
                this.validationMessage = "";
                this.powerOff();
            } else {
                this.errorFlag = false;
                this.validationMessage = "Incorrect number. Please try again.";
            }
        },
        async powerOff() {
            this.errorFlag = false;
            var self = this;
            var request = { "otp": "123" };
            let data = {}
            data.payload = request
            self.$store
                .dispatch("settingStore/shutDown", data, { root: true })
                .then(function (response) {
                    self.validationMessage = "";
                    self.userInput = "";
                    self.$emit('updateParameters', false, false);
                    swal.fire({
                        title: "Shut Down",
                        text: "Connections are ShutDown.",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                        icon: "success",
                    });
                }).catch(function (error) {
                    self.errorFlag = true;
                    self.errorMessage = error.server.response.data.message;
                });
        },
    },
};
</script>
